import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ManagementService } from '../../management.service';

@Component({
	selector: 'app-edit-organisation',
	templateUrl: './edit-organisation.component.html',
	styleUrls: ['./edit-organisation.component.scss']
})
export class EditOrganisationComponent implements OnInit {
	Form: FormGroup;
	blockLoader: string = "blockLoader";
	isDataAvailable!: boolean;
	orgCodeControl: any;
	organisationData: any;
	organisationCode: any;
	orgCodeRegex = /^[a-z0-9]+$/i;

	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private spinner: NgxSpinnerService,
		public dialogRef: MatDialogRef<EditOrganisationComponent>,
		private organisationService: ManagementService,
		private snackbar: MatSnackBar
	) {
		const d = this.data;
		// console.log('editing data', d);
		this.Form = this.fb.group({
			name: [d && d.name ? d.name : '', Validators.required],
			orgCode: [d && d.orgCode ? d.orgCode : '', Validators.required],
			imageLogo: [d && d.imageLogo ? d.imageLogo : '', Validators.required],
			active: [d && d.active ? d.active : false, Validators.required],
			progressBarLock: [d && d.progressBarLock ? d.progressBarLock : false, Validators.required],
			updatedAt: new Date(),
			// hierarchies: []
		});

		if (d) {
			this.organisationCode = d.orgCode;
		}
	}

	ngOnInit() {
		this.getOrganisation()
		this.orgCodeControl = this.Form.get('orgCode') as FormControl;
		this.setOrgCodeControlState();
	}

	async onFileChange(event: any) {
		const reader = new FileReader();

		if (event.target.files && event.target.files.length) {
			const [file] = event.target.files;

			reader.readAsDataURL(file);

			reader.onload = async () => {
				const base64Response = await fetch(reader.result as string);
				console.log(base64Response)
				this.Form.patchValue({
					imageLogo: base64Response.url
				});
			};
			// this.isImage = false;
		}
	}


	getOrganisation() {
		this.organisationService.getOrganisation().subscribe((data) => {
			if (data.length) {
				this.organisationData = data;
				// console.log('this.organisationData', this.organisationData);
			}
		});
	}


	async saveBtn() {
		const orgCodeValue = this.Form.value.orgCode;
		if (!this.orgCodeRegex.test(orgCodeValue)) {
			this.snackbar.open("Please make sure that organization code contains alphanumeric characters only", "OK");
			return;
		}

		await this.spinner.show("blockLoader");
		// console.log(this.Form.value);
		// console.log(this.organisationData);

		if (!this.data) {
			const orgCodeExists = this.organisationData.some((org: any) => org.orgCode === orgCodeValue);
			// console.log('orgCodeExists', orgCodeExists)
			if (orgCodeExists) {
				// console.log('exist')
				this.snackbar.open("Organisation Code already exists. Please choose a different Organisation Code.", "OK", {
					duration: 3000
				});
			} else {
				this.Form.value.hierarchies = [];
				this.Form.value.hierarchy = [];
				this.Form.value.createdAt = new Date();
				const response: any = await this.organisationService.addEditOrganisation(this.Form.value, '');
				this.dialogRef.close(response);
			}
		}

		if (this.data) {
			this.Form.value.orgCode = this.organisationCode;
			let getOrgData = this.organisationData.find((org: any) => {
				return org.orgCode === this.Form.value.orgCode;
			});

			if (!getOrgData.allowedPrograms) {
				getOrgData.allowedPrograms = [];
			}

			if (!getOrgData.hiddenPrograms) {
				getOrgData.hiddenPrograms = [];
			}

			if (!getOrgData.programAccess) {
				getOrgData.programAccess = [];
			}

			const orgData = {
				...this.Form.value,
				hierarchy: getOrgData.hierarchy,
				hierarchies: getOrgData.hierarchies,
				allowedPrograms: getOrgData.allowedPrograms,
				hiddenPrograms: getOrgData.hiddenPrograms,
				programAccess: getOrgData.programAccess,
				createdAt: getOrgData.createdAt
			};
			const response: any = await this.organisationService.addEditOrganisation(orgData, this.data.id);
			this.dialogRef.close(response);
		}
		await this.spinner.hide("blockLoader");
	}

	setOrgCodeControlState() {
		if (this.data) {
			this.orgCodeControl.disable();
		} else {
			this.orgCodeControl.enable();
		}
	}
}
